<template>
  <div class="help-better">
    <div class="help-item" @mouseenter="showPurchaseShow"
         @mouseleave="hidePurchaseShow" @click="changeOrder(true)">
      <div class="show-item">
        <img src="../../static/index/help/icon-1.png"></img>
        <div class="word">{{ purchaseShow ? '点击发布' : '发布询单' }}</div>
      </div>
    </div>
    <div class="help-item" @mouseenter="showProductShow"
         @mouseleave="hideProductShow" @click="goHelp('/user/supplier/my-project')">
      <div class="show-item">
        <img src="../../static/index/help/icon-2.png">
        <div class="word">{{ productShow ? '点击发布' : '发布产品' }}</div>
      </div>
    </div>
    <div class="help-item" @mouseenter="showWechatFun"
         @mouseleave="hideWechatFun">
      <div class="show-item">
        <img src="../../static/index/help/icon-3.png">
        <div class="word">公众号</div>
      </div>
      <!-- 鼠标划过展示    -->
      <transition name="el-fade-in">
        <div class="hidden-item" v-show="wechatFunShow">
          <div class="wechat-image">
            <img class="image" :src="configInfo.wechat_qrcode"/>
            <div class="watch-text-title">
              扫码关注公众号
            </div>
          </div>
          <div class="wechat-image">
            <img class="image" :src="configInfo.mini_qrcode"/>
            <div class="watch-text-title">
              立即体验小程序
            </div>
          </div>
          <div class="hotline-arrow"></div>
        </div>
      </transition>
    </div>
    <div class="help-item" @mouseenter="showMiniFun"
         @mouseleave="hideMiniFun">
      <div class="show-item">
        <img src="../../static/index/help/icon-5.png"></img>
        <div class="word">联系客服</div>
      </div>
      <transition name="el-fade-in">
        <div class="hidden-item" v-show="miniFunShow">
          <!--      没有登录的时候显示的客服-->
          <div class="mini-content" v-if="!isLogin">
            <div class="service-card" v-for="(item,index) in service" :key="index">
              <div class="service-title">免费找货、比价、找客服联系我
                <a :href="item.qw_link" target="_blank">咨询微信客服</a>
              </div>
              <div class="content-body">
                <img :src="item.avatar" alt="qq头像" class="image-box">
                <div class="service-info">
                  <div class="service-name">{{ item.name }}</div>
                  <!--              <div class="service-desc">平均15分钟内报价</div>-->
                </div>
                <img :src="item.qrcode" alt="qq头像" class="qr-box">
              </div>
              <div class="service-actions">
                <el-button type="primary" class="contact-btn phone-btn" @click="copyHotline(item.mobile)">
                  电话
                  {{ item.mobile }}
                </el-button>
                <el-button type="primary" @click="copyHotline(item.qq)" class="contact-btn qq-btn">
                  QQ
                  {{ item.qq }}
                </el-button>
              </div>
            </div>
          </div>
          <!--      登录了之后显示的客服-->
          <div class="mini-content" v-else>
            <div class="service-card">
              <div class="service-title">免费找货、比价、找客服联系我
                <a :href="kefu.qw_link" target="_blank">咨询微信客服</a>
              </div>
              <div class="content-body">
                <img :src="kefu.avatar" alt="qq头像" class="image-box">
                <div class="service-info">
                  <div class="service-name">{{ kefu.name }}</div>
                  <!--              <div class="service-desc">平均15分钟内报价</div>-->
                </div>
                <img :src="kefu.qrcode" alt="qq头像" class="qr-box">
              </div>
              <div class="service-actions">
                <el-button type="primary" class="contact-btn phone-btn" @click="copyHotline(kefu.mobile)">
                  电话
                  {{ kefu.mobile }}
                </el-button>
                <el-button type="primary" @click="copyHotline(kefu.qq)" class="contact-btn qq-btn">
                  QQ
                  {{ kefu.qq }}
                </el-button>
              </div>
            </div>
          </div>

          <div class="hotline-arrow"></div>
        </div>
      </transition>
    </div>
    <div class="help-item"
         v-if="isLogin"
         @mouseenter="showBusinessFun"
         @mouseleave="hideBusinessFun"
    >
      <div class="show-item">
        <img src="../../static/index/help/icon-6.png"></img>
        <div class="word">联系业务</div>
      </div>
      <transition name="el-fade-in">
        <div class="hidden-item" v-show="businessFunShow">
          <div class="mini-content">
            <div class="service-card">
              <div class="service-title">免费找货、比价、找业务联系我
              </div>
              <div class="content-body">
                <img :src="yewu.avatar" alt="qq头像" class="image-box">
                <div class="service-info">
                  <div class="service-name">{{ yewu.name || '' }}</div>
                  <div class="service-desc">平均15分钟内报价</div>
                </div>
                <img :src="yewu.qrcode" alt="qq头像" class="qr-box">
              </div>
              <div class="service-actions">
                <el-button type="primary" class="contact-btn phone-btn" @click="copyHotline(yewu.mobile)">
                  电话
                  {{ yewu.mobile }}
                </el-button>
                <el-button type="primary" @click="copyHotline(yewu.wechat)" class="contact-btn qq-btn">
                  微信
                  {{ yewu.wechat }}
                </el-button>
              </div>
            </div>
          </div>
          <div class="hotline-arrow"></div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import {getMyCustomerService, getWebSiteService} from "@/api";

export default {
  name: "help-better",
  props: {'showGZH': {default: false}},
  data() {
    return {
      purchaseShow: false,
      productShow: false,
      wechatFunShow: false,
      miniFunShow: false,
      businessFunShow: false,
      service: [],
      yewu: {},
      kefu: {},
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin;
    },
    configInfo() {
      return this.$store.state.config.config;
    },
  },
  created() {
    if (this.isLogin) {
      this.customerService()
    } else {
      this.init()
    }

  },
  watch: {
    showGZH(newVal) {
      if (newVal) {
        this.wechatFunShow = true;
      } else {
        this.wechatFunShow = false;
      }
    }
    ,
    isLogin(newVal) {
      if (newVal) {
        this.customerService()
      }
    }
  },
  methods: {
    goHelp(path) {
      if (this.mixCheckLogin() && this.mixCheckUserMobile()) {
        this.$router.push(path);
      }
    },
    // 修改询单状态
    changeOrder(e) {
      if (this.mixCheckLogin() && this.mixCheckUserMobile()) {
        this.$emit('changeOrder', true)
      }
    },
    async init() {
      let res = await getWebSiteService()
      if (res.data.code === 10000) {
        this.service = res.data.data
      }
    },
    async customerService() {
      let res1 = await getMyCustomerService()
      if (res1.data.code === 10000) {
        this.yewu = res1.data.data.yewu
        this.kefu = res1.data.data.kefu
      }
    },
    showPurchaseShow() {
      this.purchaseShow = true;
    },
    hidePurchaseShow() {
      this.purchaseShow = false;
    },
    showProductShow() {
      this.productShow = true;
    },
    hideProductShow() {
      this.productShow = false;
    },
    showWechatFun() {
      this.wechatFunShow = true;
    },
    hideWechatFun() {
      this.wechatFunShow = false;
    },
    showMiniFun() {
      this.miniFunShow = true;
    },
    hideMiniFun() {
      this.miniFunShow = false;
    },
    showBusinessFun() {
      this.businessFunShow = true;
    },
    hideBusinessFun() {
      this.businessFunShow = false;
    },
  }
}
</script>
<style scoped lang="scss">
.help-better {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #0540b8 0%, #0c60e6 100%);
  border-radius: 8px 0 0 8px;
  padding: 2px;
  box-sizing: border-box;
  z-index: 999;
  box-shadow: -2px 2px 10px rgba(5, 64, 184, 0.3);
  /* 应用滚动条补偿 */
  right: var(--scrollbar-width);
  cursor: pointer;

  .help-item {
    border-bottom: 1px solid #FFFFFF;
    position: relative;

    &:last-child {
      border-bottom: none;
    }
  }

  .hidden-item {
    position: absolute;
    right: 78px;
    top: 50%;
    transform: translateY(-50%);
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);

    .hotline-arrow {
      position: absolute;
      right: -8px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-left: 8px solid #ffffff;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      filter: drop-shadow(2px 0 2px rgba(0, 0, 0, 0.1));
    }

    //微信公众号
    .wechat-image {
      .image {
        width: 150px;
        height: 150px;
        object-fit: contain;
      }

      .watch-text-title {
        font-weight: 300;
        font-size: 12px;
        text-align: center;
        margin-top: 10px;
      }
    }

    //客服
    .mini-content {
      width: 350px;

      .service-card {
        margin-bottom: 16px;
        transition: transform 0.2s ease, box-shadow 0.2s ease;


        .service-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #0540b8;
          font-weight: 600;
          font-size: 14px;
          margin-bottom: 12px;
          padding-bottom: 8px;
          border-bottom: 1px dashed #e5e9f2;
        }

        .content-body {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 0;
          gap: 15px;

          .image-box {
            width: 80px;
            height: 80px;
            object-fit: cover;
            border-radius: 50%;
            border: 3px solid #e6f0ff;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
          }

          .service-info {
            flex: 1;
            min-width: 0;
            text-align: center;

            .service-name {
              font-weight: 600;
              color: #333;
              margin-bottom: 4px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .service-desc {
              font-size: 12px;
              color: #666;
            }
          }

          .qr-box {
            width: 90px;
            height: 90px;
            object-fit: contain;
            border: 1px solid #f0f0f0;
            padding: 5px;
            background: #fff;
          }
        }

        .service-actions {
          display: flex;
          gap: 10px;
          margin-top: 12px;

          .contact-btn {
            flex: 1;
            padding: 8px 0;
            border-radius: 6px;
            font-size: 13px;
            transition: all 0.2s ease;

            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 2px 8px rgba(12, 96, 230, 0.3);
            }

            &.phone-btn {
              background: #0c60e6;
              border-color: #0c60e6;
            }

            &.qq-btn {
              background: #2d8cf0;
              border-color: #2d8cf0;
            }
          }
        }
      }
    }


  }

  .show-item {
    padding: 5px;
    transition: all 0.2s ease;

    .word {
      text-align: center;
      color: #FFFFFF;
      font-size: 14px;
      transition: all 0.2s ease;
      padding-bottom: 5px;

      &:hover {
        font-weight: bold;
      }
    }


    img {
      width: 28px;
      height: 28px;
      transition: all 0.3s ease;
      filter: brightness(0) invert(1);
      object-fit: contain;
      display: block;
      margin: 8px auto 4px auto;

      &:hover {
        transform: scale(1.15) rotate(5deg);
        filter: brightness(0) invert(1) drop-shadow(0 2px 4px rgba(255, 255, 255, 0.3));
      }
    }

    //&::before {
    //  content: "";
    //  position: absolute;
    //  top: 0;
    //  right: -100%;
    //  width: 100%;
    //  height: 100%;
    //  background: linear-gradient(
    //          90deg,
    //          transparent,
    //          rgba(255, 255, 255, 0.1),
    //          transparent
    //  );
    //  transition: left 0.5s ease;
    //}

    &:hover::before {
      left: 10%;
    }
    &:hover {
      background: rgba(255, 255, 255, 0.1);
      transform: translateX(-2px);
    }
  }

}
</style>
